var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.267578,
    y: 0.900146,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#F77F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9238 9.2439L15.9238 3.90015L11.2676 3.90015L11.2676 5.90015L7.26758 5.90015L7.26758 3.90015L2.61133 3.90015L2.61133 9.2439L7.26758 9.2439L7.26758 7.2439L8.61133 7.2439L8.61133 13.9001L11.2676 13.9001L11.2676 15.9001L15.9238 15.9001L15.9238 10.5564L11.2676 10.5564L11.2676 12.5564L9.92383 12.5564L9.92383 7.2439L11.2676 7.2439L11.2676 9.2439L15.9238 9.2439ZM5.92383 7.90015L3.92383 7.90015L3.92383 5.2439L5.92383 5.2439L5.92383 7.90015ZM12.6113 11.9001L14.6113 11.9001L14.6113 14.5564L12.6113 14.5564L12.6113 11.9001ZM12.6113 5.2439L14.6113 5.2439L14.6113 7.90015L12.6113 7.90015L12.6113 5.2439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcaIcon);
export default __webpack_public_path__ + "static/media/rca_icon.13409558368b8d4dba120c088dbe29ef.svg";
export { ForwardRef as ReactComponent };